import { render, staticRenderFns } from "./NewMsuFromGroup.vue?vue&type=template&id=0666b098"
import script from "./NewMsuFromGroup.vue?vue&type=script&lang=js"
export * from "./NewMsuFromGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports